class ProductCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            slides: {
              perView: 3,
              spacing: 20,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg +
            1}px)`]: {
            slides: {
              perView: 3,
              spacing: 40,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(
          this.els.dot.elements,
          (carousel, dot, index) => {
            if (
              window.innerWidth <= window.BAO.MediaBreakpoints.breakpoints.md
            ) {
              return
            }

            const amountOfSlides = carousel.slides.length
            const slidesPerView = carousel.options.slides.perView
            const shouldHideSlide =
              index >= amountOfSlides - (slidesPerView - 1)

            dot.setAttribute('aria-hidden', shouldHideSlide.toString())
          },
        ),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
